// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"769dcd23","455":"3f5bdf0c","977":"d418f076"}[chunkId] + ".chunk.js";
};